import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DownloadButton from '../atom/DownloadButton';
import { SUCCESS_TITLE, RESTART_JOURNEY } from '../constants/TranslationConstants';

interface SuccessDisplayProps {
  fileName: string;
  sourceLanguage: string;
  onDownload: () => void;
  onRestart: () => void;
}

const SuccessDisplay = ({ fileName, sourceLanguage, onDownload, onRestart }: SuccessDisplayProps) => {
  return (
    <Box>
      <Typography 
        variant="h6" 
        sx={{ 
          fontWeight: 'bold',
          mb: 3,
          color: 'black',
          fontSize: { xs: '1.1rem', md: '1.25rem' }
        }}
      >
        {SUCCESS_TITLE}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          p: 4,
          mb: 3,
          backgroundColor: '#f9f9f9',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          minHeight: '150px'
        }}
      >
        <CheckCircleIcon 
          sx={{ 
            fontSize: '48px', 
            color: '#4caf50',
            mb: 2
          }} 
        />
        <Typography
          variant="body1"
          sx={{
            fontSize: '14px',
            textAlign: 'center'
          }}
        >
          {fileName} ({sourceLanguage})
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Button
          variant="outlined"
          onClick={onRestart}
          size="small"
          sx={{
            fontSize: "10px",
            height: "30px",
            color: "#006684",
            borderColor: "#006684",
            cursor: "pointer",
            textTransform: "capitalize",
            fontWeight: "600",
            minWidth: "140px",
            '&:hover': {
              backgroundColor: "#f0f8ff",
              borderColor: "#005a70",
              color: "#005a70"
            }
          }}
        >
          {RESTART_JOURNEY}
        </Button>
        
        <DownloadButton
          fileName={fileName}
          onDownload={onDownload}
        />
      </Box>
    </Box>
  );
};

export default SuccessDisplay;